import { Banner, Box, InlineStack, Text } from '@shopify/polaris'

import { SubscriptionContractSubscriptionStatus } from '../common/api'
import { gidToId, InternalLink } from '../common/helpers'
import { SubscriptionContract } from '../common/subscription-models'
import * as urls from '../common/urls'

export const MultipleDeliveryAddressesCard = ({ sub }: { sub: SubscriptionContract }) => {
  if (
    sub.gql_status !== SubscriptionContractSubscriptionStatus.Active &&
    sub.gql_status !== SubscriptionContractSubscriptionStatus.Paused
  ) {
    return null
  }

  return (
    <Box paddingBlockEnd="200">
      <Banner tone="warning">
        <InlineStack align="space-between" gap="200">
          <Text as="p">
            This customer has other subscriptions delivered to a different address.
          </Text>
          <InternalLink
            url={urls.subscriptionsUrl({
              customer_id: gidToId(sub.gql_customer_gid),
              status: 'active,paused',
            })}
          >
            View customer's subscriptions
          </InternalLink>
        </InlineStack>
      </Banner>
    </Box>
  )
}
